const googleDocStyle = {
  iframe: {
    maxWidth: '100%',
    margin: '10px auto',
    display: 'block',
  },
};

export default googleDocStyle;
